<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-badge-account-horizontal-outline"
      inline
      class="px-5 py-3"
      title="Informes pendientes"
    >
      <v-row>
      <v-col cols="12" lg="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="fechaDesde" color="gold" label="Desde" readonly v-on="on" clearable @input="getInformes" />
          </template>
            <v-date-picker
              v-model="fechaDesde"
              color="gold"
              landscape
              scrollable
              locale="es-419"
              no-title
              @input="menu = false"
              @change="getInformes"
            >
            </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="3">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="fechaHasta" color="gold" label="Hasta" readonly v-on="on" clearable @input="getInformes" />
          </template>
            <v-date-picker
              v-model="fechaHasta"
              color="gold"
              landscape
              scrollable
              locale="es-419"
              no-title
              @input="menu1 = false"
              @change="getInformes"
            >
            </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="6">
          <v-text-field
            v-model="buscar"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
      </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <template>
                <v-card-title class="headline">
                  ¿Realmente desea eliminar?
                </v-card-title>
              </template>
              <template v-if="dataForm.tieneAcciones">
                <v-col cols="12" class="pl-10 pb-0">
                  <v-card-subtitle class ="red--text">
                    <v-icon large color="red">
                      mdi-exclamation
                    </v-icon>
                    También eliminará las acciones.
                  </v-card-subtitle>
                </v-col>
              </template>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="informes"
        :search.sync="buscar"
        :sort-desc="[true, false]"
        multi-sort
      >
        <template v-slot:[`item.propio_sn`]="{ item }">
          <v-icon
            v-if="item.propio_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-if="$can('M_informes_edita')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_informes_edita')" v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-6"
                v-bind="attrs"
                v-on="on"
                @click.stop="goToNewInformeForm('pendiente', item.jugador_id)"
              >
                mdi-text-box-plus-outline
              </v-icon>
            </template>
            <span>Crear Informe</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        menu: false,
        menu1: false,
        fechaDesde: null,
        fechaHasta: null,
        dialogDelete: false,
        buscar: undefined,
        headers: [
          { text: 'Último informe', sortable: true, value: 'fecha' },
          { text: 'Jugador', sortable: true, value: 'jugador.fullName' },
          { text: 'Scout', sortable: true, value: 'scout.fullName' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        informes: [],
        editedIndex: -1,
        dataForm: {
          id: '',
          fecha: '',
          jugador_id: '',
          scout_id: '',
          descripcion: '',
          documento_id: null,
          tieneAcciones: false,
        },
      }
    },
    created () {
      this.getInformes()
    },
    methods: {

      getInformes: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/informe_pendientes_get/' + this.fechaDesde + '/' + this.fechaHasta }).then(response => { this.informes = response })
      },

      goToNewInformeForm: function (modeVal, jugadorId) {
        this.$router.push({ name: 'Alta Informe', params: { mode: modeVal, id: jugadorId } })
      },

      goToAsignaciones: function (idLitigio) {
        this.$router.push({ name: 'Asignaciones legales', params: { id: idLitigio } })
      },

      goToHistorial: function (idLitigio) {
        this.$router.push({ name: 'Acciones informe', params: { id: idLitigio } })
      },

      deleteItem (item) {
        this.editedIndex = this.informes.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialogDelete = true
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function () {
        await this.$http.delete('/api/informe_delete/' + this.dataForm.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Informe eliminado'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getInformes()
        this.closeDelete()
      },
    },
  }
</script>
